import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from 'src/environments/environment';
import { buildTokenConstraintsConfig } from './gemini-live-config';

@Injectable({ providedIn: 'root' })
export class EphemeralTokenService {
  private readonly http = inject(HttpClient);

  async getToken(): Promise<string> {
    const config = buildTokenConstraintsConfig();
    const response = await firstValueFrom(
      this.http.post<{ token: string; expires_in: number }>(
        `${environment.api_url}api/v1/customer/ephemeral-tokens/gemini`, { config }
      )
    );

    return response.token;
  }
}
